/**
 * Get the length of a string without counting spaces
 * (useful for a counter with a mask)
 *
 * @param {string|undefined} value The string to compute
 * @returns {number} The length of the value
 */
export function noSpacesCounter(value?: string | undefined): number {
	if (!value) {
		return 0;
	}

	return value.replace(/\s/g, '').length;
}
